import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useEffect, useState } from "react";
import { useShoppingCart } from "./context/ShoppingCartContext";
import { pf } from "./utilities/helpers";
import { matchesEditorTarget } from "./utilities/componentIdentity";
import { useAppSelector } from "../../store/hooks";
import { CartComponent as CartComponent_ } from "./interfaces/base";
import RenderChildren from "./RenderChildren";
import styled from "@emotion/styled";
import React from "react";
import { getComponentFromStructureMap } from "./utilities/componentIdentity";

const Div = styled("div")(
  null,
  (props) =>
    function (props: any) {
      return { ...props["data-style"] };
    }
);
export default function CartComponent({
  id,
  uuid,
  attributes,
  childElements,
  childWebpageComponentRelations,
}: CartComponent_) {
  const editorId = useAppSelector((state) => state.textEditor?.get("id"));
  const [mouseUp, setMouseUp] = useState<any>(null);
  const [keyDown, setKeyDown] = useState<any>(null);
  const typographies = useAppSelector((state) => state.builder.typographies);
  const [style, setStyle] = useState<React.CSSProperties>();
  const colors = useAppSelector((state) => state.builder.colors);
  const [hoverStyle, setHoverStyle] = useState<any>();
  const [isHovered, setIsHovered] = useState(false);
  const [borderColors, setBorderColors] = useState<any>();

  const component = (useAppSelector((state) =>
    getComponentFromStructureMap(state.builder.structure.components, uuid ?? id)
  ) as CartComponent_) ?? ({
    id: typeof id === "number" ? id : -1,
    parent_id: null,
    childElements: childElements ?? [],
    childWebpageComponentRelations: childWebpageComponentRelations ?? [],
    sort_order: 0,
    type: "cart",
    uuid: uuid ?? null,
    version: 1,
    webpage_id: 0,
    attributes,
  } as CartComponent_);

  const { toggleCart, cartItems, order, totalCartSum } =
    useShoppingCart();

  const deliveryPrice =
    order?.delivery && cartItems.length > 0
      ? Number(order.delivery.taxInclusivePriceAmount ?? 0)
      : 0;

  useEffect(() => {
    const compTypography = typographies?.find(
      (x: any) => x.id === attributes.typography_id
    );
    if (compTypography) {
      setStyle({
        display: "flex",
        alignItems: "center",

        fontSize: compTypography.fontSize + compTypography.fontSizeUnit,
        fontFamily: compTypography.fontFamily,
        color: colors?.find((x: any) => x.id === compTypography.colorId)
          ?.color,
        transition:
          compTypography.transitionDuration +
          " color " +
          compTypography.transitionEffect,
      });
      setHoverStyle({
        "&:hover, &:hover > svg, &:hover > div": {
          color:
            colors?.find(
              (x: any) => x.id === compTypography.linkHoverColorId
            )?.color + " !important",
        },
      });
    }
  }, [typographies, attributes]);

  useEffect(() => {
    // Change border color values

    const borderColorValues = {
      borderTopColor: component.attributes?.borderTopColorId
        ? colors?.find(
            (x: any) => x.id === component.attributes?.borderTopColorId
          )?.color
        : component.attributes?.styles.borderTopColor
        ? component.attributes?.styles.borderTopColor
        : "",
      borderBottomColor: component.attributes?.borderBottomColorId
        ? colors?.find(
            (x: any) => x.id === component.attributes?.borderBottomColorId
          )?.color
        : component.attributes?.styles.borderBottomColor
        ? component.attributes?.styles.borderBottomColor
        : "",
      borderLeftColor: component.attributes?.borderLeftColorId
        ? colors?.find(
            (x: any) => x.id === component.attributes?.borderLeftColorId
          )?.color
        : component.attributes?.styles.borderLeftColor
        ? component.attributes?.styles.borderLeftColor
        : "",
      borderRightColor: component.attributes?.borderRightColorId
        ? colors?.find(
            (x: any) => x.id === component.attributes?.borderRightColorId
          )?.color
        : component.attributes?.styles.borderRightColor,
    };

    setBorderColors(borderColorValues);
  }, [
    component.attributes,
    component.attributes.styles,
    component.attributes?.borderBottomColorId,
    component.attributes?.borderLeftColorId,
    component.attributes?.borderRightColorId,
    component.attributes?.borderTopColorId,
    colors,
  ]);

  return (
    <div
      id={id.toString()}
      data-component-type="cart"
      className={
        (attributes.classes ?? "") +
        " builder-component builder-component__cart" +
        (matchesEditorTarget({ id, uuid }, editorId)
          ? " builder-component--active"
          : "")
      }
      style={{
        cursor: "pointer",
        width: "fit-content",
        display: "inline-grid",
        ...style,
        ...attributes.styles,
        borderLeftColor: borderColors?.borderLeftColor,
        borderRightColor: borderColors?.borderRightColor,
        borderTopColor: borderColors?.borderTopColor,
        borderBottomColor: borderColors?.borderBottomColor,
      }}
      data-style={{
        ...style,
        ...attributes.styles,
      }}
    >
      <RenderChildren
        key={id + "children"}
        childWebpageComponentRelations={childWebpageComponentRelations}
      />
      <Div
        style={{ display: "flex", alignItems: "center" }}
        onClick={() => toggleCart()}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <ShoppingCartIcon
          style={{
            fontSize: "21px",
            color: isHovered
              ? component.attributes.hoverColor
                ? component.attributes.hoverColor
                : component.attributes.color
              : component.attributes.color
              ? component.attributes.color
              : "#000",
          }}
          onMouseEnter={() => {}}
          onMouseLeave={() => {}}
        />

        <div
          style={{
            fontSize: "14px",
            paddingLeft: "3px",
            paddingRight: "3px",
            color: isHovered
              ? component.attributes.hoverColor
                ? component.attributes.hoverColor
                : component.attributes.color
              : component.attributes.color
              ? component.attributes.color
              : "#000",
            fontWeight: "600",
            whiteSpace: "nowrap",
          }}
          contentEditable={matchesEditorTarget({id, uuid}, editorId)}
          suppressContentEditableWarning={true}
          onMouseUp={(e) => setMouseUp(e)}
          onKeyDown={(e) => setKeyDown(e)}
          onMouseEnter={() => {}}
          onMouseLeave={() => {}}
        >
          {pf(totalCartSum + (order?.delivery ? deliveryPrice : 0))} €
        </div>
      </Div>
    </div>
  );
}
